<mmx-stripe-form
  #stripeForm
  *ngIf="provider === PaymentProvider.STRIPE"
  [providerConfiguration]="providerConfiguration"
  (completed)="stripeUpdated($event)">
</mmx-stripe-form>
<mmx-tilled-form
  #tilledForm
  *ngIf="provider === PaymentProvider.TILLED"
  [tilledId]="providerConfiguration.tilledId"
  [tilledPublicKey]="providerConfiguration.tilledPublicKey"
  [tilledProductionMode]="providerConfiguration.tilledProductionMode">
</mmx-tilled-form>

<mat-checkbox
  *ngIf="formConfiguration.forcedSave; else saveChekbox"
  color="primary"
  [formControl]="saveConsentControl"
  (change)="formUpdated.emit()"
>
  {{ 'payment-card.agree-to-save' | translate }}. <ng-container *ngTemplateOutlet="termsLabel"></ng-container>
</mat-checkbox>

<ng-template #saveChekbox>
  <mat-checkbox *ngIf="formConfiguration.allowSave" color="primary" [formControl]="saveControl">
    {{ 'payment-card.save-card' | translate }}. <ng-container *ngTemplateOutlet="termsLabel"></ng-container>
  </mat-checkbox>
</ng-template>

<ng-template #termsLabel>
  <a color="primary" (click)="openTerms($event)">{{ 'payment-card.terms' | translate }}</a>.
</ng-template>
